import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import Fa from 'react-fontawesome';
import { keys, keyBy, orderBy, reduce, find } from 'lodash';
import ProgressBar from '../../../../components/progress-bar';
import { fetchInactiveStageMappings, updateInactiveStageMappings, deleteInactiveStageMappings } from '../../SetupActions';
import { getViewableDimensions } from '../../../App/AppReducer';
import LabelCellRenderer from '../FilterPage/LabelCellRenderer';

import styles from './styles.css';



function StageCellRenderer(params) {
  const { value, context: { refs } } = params;
  let display = value;
  if (value && refs[value]) {
    const val = refs[value];
    if (val) {
      display = val.label;
    }
  }
  const cls = display !== null ? 'text-active' : 'text-muted';
  if (!display) {
    display = '[Select an active stage]';
  }
  return (<div className={`${cls} ${styles.cell}`}>{display}</div>);
}

class InactiveStageMappingPage extends Component {
  constructor() {
    super();
    this.state = {
      inactiveStages: [],
      loading: true,
      loaded: false,
      refs: {},
    };
    this.getCellEditorParams = this.getCellEditorParams.bind(this);
    this.valueSetter = this.valueSetter.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  getCellEditorParams() {
    const { refs } = this.state;
    return {
      values: [...keys(refs), null],
      formatValue: value => (refs[value] || { label: '[exclude]' }).label,
    };
  }

  loadData() {
    this.setState({ loading: true, loaded: false });
    this.props.dispatch(fetchInactiveStageMappings())
      .then(
        ({ inactiveStages, activeStages }) => {
          const refs = keyBy(activeStages, 'stage_id');
          this.setState({
            inactiveStages: orderBy(inactiveStages, ['sort_order'], ['asc']),
            loaded: true,
            loading: false,
            refs,
          });
        },
        () => {
          this.setState({
            inactiveStages: [],
            refs: {},
            loaded: false,
            loading: false,
          });
        },
      );
  }

  valueSetter(params) {
    const { data, newValue } = params;
    const inactiveStageId = data.stage_id;
    const current = find(this.state.inactiveStages, { stage_id: inactiveStageId });
    if (current.map_to_stage_id === newValue) {
      return false;
    }
    let prom = null;

    if (newValue) {
      prom = this.props.dispatch(updateInactiveStageMappings(inactiveStageId, { toStageId: newValue }));
    } else {
      prom = this.props.dispatch(deleteInactiveStageMappings(inactiveStageId));
    }
    /* assume success */
    this.setState({
      inactiveStages: reduce(this.state.inactiveStages, (items, item) => {
        if (item.stage_id === inactiveStageId) {
          items.push({
            ...item,
            map_to_stage_id: newValue,
          });
        } else {
          items.push(item);
        }
        return items;
      }, []),
    });
    prom.then(
      () => {
        // do nothing
      },
      () => {
        // reverse if error
        this.setState({
          inactiveStages: reduce(this.state.inactiveStages, (items, item) => {
            if (item.stage_id === inactiveStageId) {
              items.push({
                ...item,
                map_to_stage_id: current,
              });
            } else {
              items.push(item);
            }
            return items;
          }, []),
        });
      },
    );
    return true;
  }

  renderTable() {
    const { inactiveStages, refs } = this.state;
    const {
      viewableDimensions: { height, width },
    } = this.props;

    const mainColWidth = 250;
    const columnDefs = [
      {
        field: 'label',
        headerName: 'Inactive Stage',
        suppressMenu: true,
        cellRenderer: LabelCellRenderer,
        suppressMovable: true,
        suppressToolPanel: true,
        cellRendererParams: {
          showStar: false,
        },
        width: mainColWidth,
      },
      {
        field: 'map_to_stage_id',
        headerName: 'Mapped To Active Stage',
        suppressMenu: true,
        suppressMovable: true,
        suppressSorting: true,
        suppressToolPanel: true,
        suppressMiniFilter: true,
        editable: true,
        cellEditor: 'agRichSelectCellEditor',
        cellEditorParams: this.getCellEditorParams,
        valueSetter: this.valueSetter,
        cellRenderer: StageCellRenderer,
        singleClickEdit: true,
        width: Math.max(150, width - mainColWidth - 4),
      },
    ];

    return (
      <div className={`ag-theme-alpine ${styles.table}`} style={{ height, width: '100%' }}>
        <AgGridReact
          reactNext
          context={{ refs }}
          enableColResize
          enableSorting
          animateRows
          groupUseEntireRow
          groupDefaultExpanded={-1}
          groupRowInnerRenderer="groupRowInnerRenderer"
          columnDefs={columnDefs}
          getRowNodeId={data => data.stage_id}
          onGridReady={this.onGridReady}
          rowData={inactiveStages}
        />
      </div>
    );
  }

  render() {
    const { loaded, loading } = this.state;
    const isLoading = !loaded || loading;
    return (
      <div>
        <Helmet title="Inactive Stage Mappings | Sales Stages" />
        <div className="container">
          {isLoading && <ProgressBar />}
          {!isLoading && this.renderTable()}
        </div>
      </div>
    );
  }
}

InactiveStageMappingPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  viewableDimensions: PropTypes.shape({
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    viewableDimensions: getViewableDimensions(state),
  };
}

export default connect(mapStateToProps)(InactiveStageMappingPage);

